module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Roboto/Roboto-Thin.woff2
// module id = 3461
// module chunks = 0